import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  hideShowFilters: false,
  showAdvancedPathwaysPanel: false,
  currentDisplayPanelIndex: 0,
  hideShowZeroStateViews: false,
  globalErrorMessage: null,
  currentSelectedPatientTabIndex: 0,
  togglePersistence: false,
  userConsentData: {},
  hasOrganizationEnabledEmr: null,
};

const globalSlices = createSlice({
  name: 'global',
  initialState,
  reducers: {
    setGlobalErrorMessage: (state, action) => {
      state.globalErrorMessage = action.payload;
    },
    hideShowFilters: (state, action) => {
      state.hideShowFilters = action.payload;
    },
    showAdvancedPathways: (state, action) => {
      state.showAdvancedPathwaysPanel = action.payload;
    },
    setCurrentDisplayPanelIndex: (state, action) => {
      state.currentDisplayPanelIndex = action.payload;
    },
    hideShowZeroStateViews: (state, action) => {
      state.hideShowZeroStateViews = action.payload;
    },
    setCurrentSelectedPatientTabIndex: (state, action) => {
      state.currentSelectedPatientTabIndex = action.payload;
    },
    setUserConsentData: (state, action) => {
      state.userConsentData = { ...state.userConsentData, ...action.payload };
    },
    setUserType: (state, action) => {
      state.userType = { ...state.userType, ...action.payload };
    },
    setHasOrganizationEnabledEmr: (state, action) => {
      state.hasOrganizationEnabledEmr = action.payload;
    },
    /* DEVELOPMENT USE ONLY BELOW */
    togglePersistence: (state, action) => {
      state.togglePersistence = action.payload;
    },
  },
});

export const {
  hideShowFilters,
  setCreatedPatientID,
  setCurrentDisplayPanelIndex,
  showAdvancedPathways,
  togglePersistence,
  setGlobalErrorMessage,
  setCurrentSelectedPatientTabIndex,
  setUserConsentData,
  setUserType,
  setHasOrganizationEnabledEmr,
} = globalSlices.actions;
export default globalSlices.reducer;
